import { addDoc, collection, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { auth, db, storage } from "../../config/firebase";

export type OrganizationType = "school" | "club" | "league";

export interface Organization {
    id: string;
    name: string;
    type: string;
    logoUrl?: string;
    primaryColor?: string;
    secondaryColor?: string;
}

export interface CreateOrganizationInput {
    name: string;
    type: OrganizationType;
    primaryColor: string;     
    secondaryColor: string;   
    logoFile?: File | null;         
}

export async function createOrganization(
  input: CreateOrganizationInput
): Promise<string> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("User must be authenticated to create an organization.");
  }

  const orgData = {
    name: input.name,
    type: input.type,
    createdBy: user.uid,
    createdAt: serverTimestamp(),
    admins: [user.uid],
    primaryColor: input.primaryColor || null,
    secondaryColor: input.secondaryColor || null,
  };

  const docRef = await addDoc(collection(db, "organizations"), orgData);

  if (input.logoFile) {
    const logoUrl = await uploadOrganizationLogo(input.logoFile, docRef.id);
    await updateDoc(doc(db, "organizations", docRef.id), {
      logoUrl,
    });
  }

  return docRef.id;
}

export async function updateOrganization(orgId: string, updates: Partial<Organization>) {
    const orgRef = doc(db, "organizations", orgId);
    await updateDoc(orgRef, updates);
}

export async function uploadOrganizationLogo(file: File, orgId: string): Promise<string> {
  const storageRef = ref(storage, `orgs/${orgId}/logo.png`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
}